import { render, staticRenderFns } from "./ButtonForDecisionMaking.vue?vue&type=template&id=770fb6e1&"
import script from "./ButtonForDecisionMaking.vue?vue&type=script&lang=js&"
export * from "./ButtonForDecisionMaking.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports